import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { useCurrentUserInfo } from 'hooks/useCurrentUserInfo';

const styles = {
  srOnly: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    borderWidth: '0',
  },
};

export const ScreenReaderContent = ({ words }) => {
  const { isSuperAdminPermissions } = useCurrentUserInfo();

  return (
    <Box className="sr-only" aria-live="polite" sx={styles.srOnly}>
      {words.map(({ text, value, versions = [] }) => (
        <span key={text}>
          {text}: {value}. {isSuperAdminPermissions && versions.length ? ` Versions: ${versions.join(', ')}` : ''}
        </span>
      ))}
    </Box>
  );
};

ScreenReaderContent.propTypes = {
  words: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
      versions: PropTypes.arrayOf(PropTypes.string),
    }),
  ).isRequired,
};
